import React, { useEffect, useState, useRef } from "react";
import { message, notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, LeftBackButtonText, Spinner, Text } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import {
  addSubscriptionV2LinkPaymentMethod,
  getSubscriptionLinkManualInvoice,
  manualSubscritpionV2LinkPaymentMethod,
  findSubscriptionV2LinkById,
  BASE_URLS,
  getSecretValuesById,
  getServerEncription,
  generateClientKeyPair,
  encryptData,
  getPayPalClientToken,
  getMrn,
  action,
} from "../../api";
import { MESSAGES, SWIREPAY_URL, TabNames, LPG_CUSTOMER, SESSION_TIME, ACQUIRER_TYPE_PAYPAL, ACQUIRER_TYPE_PAYPAL_BNY } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./components/smallscreen/header";
import { AmountDivideByHundred } from "../../helper";
import Support from "../../components/support";
import SmallScreenFooter from "../../components/smallscreen/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import PaymentExpandableRows from "../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../components/PaymentExpandableRowsV2";
import getformatteddate from "../../utils/getformatteddate";
import getRedirectionUrl from "../../utils/getRedirectionUrl";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import AchPayment from "../../components/achPaymentWithPlaid";
import BankPayment from "../../components/bankpayment/BankPayment";
import UpiPayment from "../../components/upipayment/UpiPayment";
import Apple from '../../routes/apple';
import GooglePay from "../../components/googlePay/GooglePay";
import RecaptchaModal from "../../components/recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../redux/customerDetailsInfo";
import ApplePayButton from '../../routes/apple/PayPalApplePay';
import PayPalGooglePay from "../../components/payPalGooglePay";
import { setFormData } from "../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../components/SavedPaymentMethods";
import queryString from "query-string";

type Props = {
  history: {
    push: Function,
  },
}

const AddPaymentMethodV2 = (props: Props) => {

  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
  const [account, setAccount] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
  const [transactionModalBodyText, setTransactionModalBodyText] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState('');
  const paymentSelected = sessionStorage.getItem('slectedPayment');
  const hostName = (window && window.location && window.location.host);
  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [gpayError, setGpayError] = useState(null);
  const [payment, setPayment] = useState(null);
  const [applePayment, setApplePayment] = useState(false);
  const [isApplePay, setIsApplePay] = useState(false);
  const [link, setLink] = useState(SWIREPAY_URL);
  const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
  const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
  const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
  const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
  const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
  const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
  const dispatch = useDispatch();
  const [payPalClientAuth, setPayPalClientAuth] = useState('');
  const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
  const isPayPalApple = useRef(false);
  const isPayPalGoogle = useRef(false);
  const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
  const [manualInvoiceDetail, setManualInvoiceDetail] = useState(null);

  const { match: { params: { id } }, location: { pathname, search } } = props;
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${id}`) || undefined);
  const paramsId = id;

  const getPayPalAccountInfo = async (id) => {
    try {
      const payPalInfo = await getPayPalClientToken(id);
      setPayPalClientAuth(payPalInfo);
      return payPalInfo;
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  useEffect(() => {
    const acquirer = payment?.account?.acquirer;
    if (payment?.account?.gid && (acquirer === ACQUIRER_TYPE_PAYPAL || acquirer === ACQUIRER_TYPE_PAYPAL_BNY)) {
      getPayPalAccountInfo(payment?.account?.gid);
    }
  }, [payment]);

  useEffect(() => {
    if (!props?.history?.location?.search || !id) return;
    const parsed = queryString.parse(props?.history?.location?.search);
    if (parsed['manual_payment'] === 'true') {
      getSubscriptionLinkManualInvoice(id).then(entity => setManualInvoiceDetail(entity));
    }
  }, [props?.history?.location?.search, id]);

  const s2PaymentMethodGid = new URLSearchParams(search).get('s2PaymentMethodGid');
  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (search) {
      getSubscriptionLinkDataWithSearchValue();
    } else {
      getSubscriptionLinkDataWithoutSearchValue();
    }
  }, [id, search]);

  useState(() => {
    if (window.ApplePaySession && window.ApplePaySession.supportsVersion(14)) {
      setIsApplePay(true);
    }
  }, []);

  useEffect(() => {
    if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
        if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
            setSubscription((prev) => ({...prev, customer: { ...prev.customer, name: updateCustomerRedux.customerDetails.name } }));
        };
        if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
            setSubscription((prev) => ({...prev, customer: { ...prev.customer, email: updateCustomerRedux.customerDetails.email } }));
        };
        if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
            && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'
        ) {
            setSubscription((prev) => ({...prev, customer: { ...prev.customer, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber } }));
        };
        dispatch(setUpdateStatus(false));
    };
  }, [updateCustomerRedux]);

  useEffect(() => {
    setSubscriptionId(subscription && subscription.gid);
    if (subscription && subscription.currency && subscription.currency.name) {
      let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
      if (subscription && subscription.paymentMethod && subscription.paymentMethod.bank) {
        setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification process, you might see a temporary hold of ${amount} in your bank account.`)
      } else {
        setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${amount}`)
      }

    }
  }, [subscription]);

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
      const values = await getSecretValuesById(accountGid, null);
      setGpaySecretValues(values);
    } catch (error) {
      setGpayError('Missing merchant details. Please contact support');
    }
  };

  // for card payment method
  const addPaymentMethod = async (data, recaptchaToken = null) => {
    const { card, cvv, expiry, name } = data;
    const cardExpiry = expiry.split(" / ");
    const number = card.replace(/\s+/g, '');
    const paymentMethodBillingAddress = (account && account.collectBillingAddress) ? {city: data.billcity || null, countryCode : (data.country && data.country) || null, state: (data.billstate && (data.billstate === 'TG' ? 'TS' : (data.billstate === 'UT' ? 'UK' : (data.billstate === 'DH' ? 'DN' : data.billstate)))) || null,
        street: data?.billaddress ? (`${data.billaddress} ${data.billaddress1 || ''}`).trim() : null }
         : null;
    const postalCode =  (account && account.collectBillingAddress) ?  (data.zipCode || null) : null;
    const paymentMethodDetails = { type: "CARD", postalCode, paymentMethodBillingAddress, card: { cvv, name, number, expiryMonth: cardExpiry[0], expiryYear: cardExpiry[1] } };
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
     };
     paymentMethodDetails.userAgent = userAgent;
     paymentMethodDetails.setAsDefault = true;
    if(s2PaymentMethodGid) {
      paymentMethodDetails.subscription2PaymentMethodGid = s2PaymentMethodGid;
    }
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...paymentMethodDetails,
                customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethodDetails), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          };
          if (encriptedData?.keyId) {
            let value = null;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              if (value?.paymentStatus === 'REQUIRE_CONFIRMATION') {
                setManualPlaidPayment(true);
              }
              const timeOut = value?.paymentStatus === 'REQUIRE_CONFIRMATION' ? SESSION_TIME.MANUAL_PLAID : 5000;
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}?sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, timeOut);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const onGlobalCaptchaVerified = async (token) => {
    setRecaptchaModalVisible(false);
    switch (recaptchaPaymentType) {
      case 'upi':
        setPaymentLinkUpiGlobalRecaptcha(token);
        break;
      case 'paypalGooglePay':
        if (savedPaymentDetails) {
          addPaypalGooglePayMethod(savedPaymentDetails, token);
        }
        break;
      case 'cardPointGooglePay':
        addGooglePayMethod(savedPaymentDetails, token);
        break;
      case 'applePay':
        addApplePayMethod(null, null, null, null, null, null, null, null, null, null, null, null, null, token, savedPaymentDetails);
        break;
      case 'ach':
        addACHMethod(savedPaymentDetails, token);
        break;
      case 'bankMethod':
        addBankMethod(savedPaymentDetails, token);
        break;
      case 'supportPaymentMethod':
        chargeBySavedPaymentMethods(savedPaymentDetails, token);
        break;
      default:
        await addPaymentMethod(savedPaymentDetails, token);
    }
    setRecaptchaPaymentType(null);
  }

  const addACHMethod = async (data, recaptchaToken = null) => {
    const { paymentMethod } = data;
    if(s2PaymentMethodGid) {
      paymentMethod.subscription2PaymentMethodGid = s2PaymentMethodGid;
    }
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...paymentMethod,
                customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethod), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          };
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}&sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, 5000);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }

    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('ach');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const addUPIMethod = async (data, recaptchaToken = null) => {
    const { paymentMethod } = data;
    if(s2PaymentMethodGid) {
      paymentMethod.subscription2PaymentMethodGid = s2PaymentMethodGid;
    }
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...paymentMethod,
                customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethod), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          };
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}&sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, 5000);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('upi');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const addBankMethod = async (data, recaptchaToken = null) => {
    const { customerGid, fundingSourceId } = data;
    const constructedPayload = {
      bank: {
        referenceId: fundingSourceId,
      },
      customerGid,
      type: "ACH"
    };
    if(s2PaymentMethodGid) {
      constructedPayload.subscription2PaymentMethodGid = s2PaymentMethodGid;
    }
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...constructedPayload,
                // customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(constructedPayload), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}&sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, 5000);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('bankMethod');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const addPaypalGooglePayMethod = async (data, recaptchaToken = null) => {
    const paymentMethod = {
      type: "WALLET",
      subType: "GOOGLE_PAY_US",
      googlePayUS: {
        apiVersionMinor: data.apiVersionMinor,
        apiVersion: data.apiVersion,
        paymentMethodDescription: data.paymentMethodData.description,
        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
        paymentMethodType: data.paymentMethodData.type,
        paymentMethodInfo: data.paymentMethodData.info
      },
    };
    if(s2PaymentMethodGid) {
      paymentMethod.subscription2PaymentMethodGid = s2PaymentMethodGid;
    }
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...paymentMethod,
                customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethod), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const values = await getPayPalAccountInfo(payment?.account?.gid);
              if (values) {
                const orderId = await getMrn(value.paymentSessionGid, value.psClientSecret);
                // Step 2: confirm PayPal order
                await window.paypal.Googlepay().confirmOrder({
                    orderId,
                    paymentMethodData: data?.paymentMethodData,
                });
                // Step 3: capture/perform final action
                await action(value.paymentSessionGid, value.psClientSecret);
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}&sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, 5000);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('paypalGooglePay');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const addGooglePayMethod = async (data, recaptchaToken = null) => {
    const paymentMethod = {
      type: "WALLET",
      subType: "GOOGLE_PAY_US",
      googlePayUS: {
        apiVersionMinor: data.apiVersionMinor,
        apiVersion: data.apiVersion,
        paymentMethodDescription: data.paymentMethodData.description,
        paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
        paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
        paymentMethodType: data.paymentMethodData.type,
        paymentMethodInfo: data.paymentMethodData.info
      },
    };
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...paymentMethod,
                customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethod), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}&sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, 5000);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('cardPointGooglePay');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const addApplePayMethod = async (deviceData, amount, customerName, customerEmail,
                                   customerPhone, countryCode, stateCode, street, postalCode, city,
                                   cardNetwork, cardType, cardLast4, recaptchaToken = null, savedPaymentMethod = null) => {
    let paymentMethod = null; 
    if (savedPaymentMethod) {
      paymentMethod = savedPaymentMethod;
    } else {
      const billingAddress = {
        city: city,
        countryCode: countryCode,
        state: stateCode,
        street: street
      };
      paymentMethod = {
        applePayUS: {
          deviceData: deviceData,
          cardBrand: cardNetwork,
          cardFundingType: cardType,
          applePayDynamicLast4: cardLast4,
          cardLast4: cardLast4
        },
        type: "WALLET",
        subType: "APPLE_PAY_US",
        postalCode: postalCode,
        paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
      }
      if(s2PaymentMethodGid) {
        paymentMethod.subscription2PaymentMethodGid = s2PaymentMethodGid;
      }
    }
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod: {
                ...paymentMethod,
                customerGid: subscription?.customer?.gid,
              },
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethod), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const values = await getPayPalAccountInfo(payment?.account?.gid);
              if (values) {
                return value;
              } else {
                const { redirectUri, setupSession } = value;
                if (setupSession && setupSession.nextActionUrl) {
                  window.location = setupSession.nextActionUrl;
                  return;
                }
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                setTimeout(function () {
                  const uri = getRedirectionUrl(hostName);
                  if (manualInvoiceDetail) {
                    props.history.push(`/subscription2-link/${id}`);
                  } else if (redirectUri) {
                    window.location = `${redirectUri}&sp-subscription-link=${id}`;
                  } else if (uri) {
                    window.location = `${uri}subscriptions/${subscriptionId}`;
                  }
                }, 5000);
              }
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('applePay');
        setSavedPaymentDetails(paymentMethod);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }

  }

  const getSubscriptionLinkDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    try {
      const value = await findSubscriptionV2LinkById(id, null);
      if (value) {
        setData(value);
        value.currency = value?.account?.currency;
        value.amount = value?.subscription2?.total ? value.subscription2.total : value?.subscription2?.amount;
        setPayment(value);
        // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        // }
      }
      setApplePayment(value?.account?.supportedRecurringPaymentTypes.includes('APPLE_PAY_US'));
      if ((value?.account?.supportedRecurringPaymentTypes).includes('GOOGLE_PAY_US') || (value?.account?.supportedRecurringPaymentTypes).includes('WALLET')) {
        await getGooglePayMerchantValues(value && value.account && value.account.gid);
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    } finally {
      setShowSpinner(false)
    }
  };

  const getSubscriptionLinkDataWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!params.get('ss') || !params.get('secret')) {
      return getSubscriptionLinkDataWithoutSearchValue();
    }
    setShowSpinner(true);
    try {
      const value = await findSubscriptionV2LinkById(id, search);
      if (value) {
        const { redirectUri } = value;
        setData(value);
        value.amount = value?.subscription2?.total ? value.subscription2.total : value?.subscription2?.amount;
        value.currency = value?.account?.currency;
        setPayment(value);
        setTransactionSuccessModalOpen(true);
        setApplePayment(value?.account?.supportedRecurringPaymentTypes.includes('APPLE_PAY_US'));
        if ((value?.account?.supportedRecurringPaymentTypes).includes('GOOGLE_PAY_US') || (value?.account?.supportedRecurringPaymentTypes).includes('WALLET')) {
          await getGooglePayMerchantValues(value && value.account && value.account.gid);
        }
        setTimeout(function () {
          const uri = getRedirectionUrl(hostName);
          if (redirectUri) {
            window.location = `${redirectUri}&sp-subscription-link=${id}`;
          } else if (uri) {
            window.location = `${uri}subscriptions/${subscriptionId}`;
          }
        }, 5000);
      }
    } catch (reason) {
      await getSubscriptionLinkDataWithoutSearchValue();
      error(reason);
    } finally {
      setShowSpinner(false);
    }
  };

  const setData = data => {
    if (data) {
      setSubscription(data.subscription2);
      dispatch(setFormData({ code: 'CUSTOMER_DETAIL',
        value: {
          phoneNumber: getCountryCodeAndNumber(data?.subscription2?.customer?.phoneNumber)?.phoneNumber,
          countryCode: getCountryCodeAndNumber(data?.subscription2?.customer?.phoneNumber)?.countryCode || '+1',
          name: data?.subscription2?.customer?.name,
          email: data?.subscription2?.customer?.email,
          disablePhone: !!data?.subscription2?.customer?.phoneNumber,
          disableEmail: !!data?.subscription2?.customer?.email,
          disableName: !!data?.subscription2?.customer?.name,
        } 
      }));
      setAccount(data.account);
      setSupportedPaymentTypes(data.account && data.account.supportedRecurringPaymentTypes);
      setBackButtonUrl(data.redirectUri || SWIREPAY_URL);
      setLink(data.link || SWIREPAY_URL);
    }
  };

  const error = reason => {
    setErrorMessage(null);
    if (!reason) return;
    const  message = reason?.response?.data?.message || reason?.message;
    setErrorMessage(message);
    setTransactionModalOpen(false);
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const onSubmit = data => {
    let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${amount}`)
    setTransactionModalOpen(true);
    addPaymentMethod(data)
  };

  const onAchPayment = data => {
    let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification process, you might see a temporary hold of ${amount} in your bank account.`)
    setTransactionModalOpen(true);
    addACHMethod(data)
  };

  const onGooglePay = data => {
    let amount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${amount}`)
    setTransactionModalOpen(true);
    if (payPalClientAuth) {
      addPaypalGooglePayMethod(data);
    } else {
      addGooglePayMethod(data);
    }
  };

  const chargeBySavedPaymentMethods = async (data, recaptchaToken = null) => {
    const paymentMethod = { ...data };
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          let encriptedData = null;
          if (manualInvoiceDetail) {
            const manualPaymentPayload = {
              gid: manualInvoiceDetail?.gid,
              amountToPay: manualInvoiceDetail?.totalAmount,
              paymentMethod,
            };
            encriptedData = encryptData(JSON.stringify(manualPaymentPayload), values.public_key, keys.privateKey, values.key_id);
          } else {
            encriptedData = encryptData(JSON.stringify(paymentMethod), values.public_key, keys.privateKey, values.key_id);
          }
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            let value;
            if (manualInvoiceDetail) {
              value = await manualSubscritpionV2LinkPaymentMethod(id, payload);
            } else {
              value = await addSubscriptionV2LinkPaymentMethod(id, payload);
            }
            if (value) {
              if (manualInvoiceDetail && value?.status !== 'SUCCEEDED') {
                setTransactionModalOpen(false);
                error({ message: 'Payment processing failed. Please try again.' });
                return;
              }
              const { redirectUri, setupSession } = value;
              if (setupSession && setupSession.nextActionUrl) {
                window.location = setupSession.nextActionUrl;
                return;
              }
              setTransactionModalOpen(false);
              setTransactionSuccessModalOpen(true);
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                if (manualInvoiceDetail) {
                  props.history.push(`/subscription2-link/${id}`);
                } else if (redirectUri) {
                  window.location = `${redirectUri}&sp-subscription-link=${id}`;
                } else if (uri) {
                  window.location = `${uri}subscriptions/${subscriptionId}`;
                }
              }, 5000);
            } else if (value === null && (payment?.subscription2?.total === 0 || payment?.subscription2?.total === null)) {
              setTransactionSuccessModalOpen(true);
              setTimeout(() => props.history.push(`/subscription2-link/${id}`), 5000);
            } 
          }
        }
      }

    } catch (reason) {
      if (reason?.status === 429){
        setRecaptchaPaymentType('supportPaymentMethod');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const onApplePay = (paymentData) => {
      const {
          deviceData,
          amount,
          customerName,
          customerEmail,
          customerPhone,
          countryCode,
          stateCode,
          street,
          postalCode,
          city,
          cardNetwork,
          cardType,
          cardLast4,
      } = paymentData;
    let verifyAmount = currencyFormatter(1, subscription.currency && subscription.currency.name);
    setTransactionModalBodyText(`You will be redirected once verification is complete\n. As part of the verification, if using a debit or credit card you might see a temporary hold of ${verifyAmount}`)
    setTransactionModalOpen(true);
    addApplePayMethod(deviceData, amount, customerName, customerEmail,
                customerPhone, countryCode, stateCode, street, postalCode, city,
                cardNetwork, cardType, cardLast4);
  };

  const uniquePaymentTypes = supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
  if(uniquePaymentTypes.indexOf('APPLE_PAY_US') > -1) {
    uniquePaymentTypes.splice(uniquePaymentTypes.indexOf('APPLE_PAY_US'), 1);
  }
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    let id;
    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerReadOnly={false}
        submit={onAchPayment}
        preFillCustomer={subscription && subscription.customer}
        customerDisabled={false}
        headerText={null}
        buttonText={manualInvoiceDetail ? "Pay" : "Save Payment"}
        customerValidation={true}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={account?.gid}
        paymentLinkId={paramsId}
        isManualPlaidNotSupport={true}
        isTest={account?.portal?.test}
        enableConsentCheckbox={true}
        accountName={account?.name}
        paymentDate={getformatteddate(subscription.nextPaymentDate, account && account.timezone)}
        finalPayAmount={currencyFormatter(AmountDivideByHundred(payment?.amount), subscription.currency && subscription.currency.name)}
      />
      id = name;
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerReadOnly={true}
        submit={onSubmit}
        preFillCustomer={subscription && subscription.customer}
        headerText={"ADD CARD"}
        buttonText={manualInvoiceDetail ? "Pay" : "Save Payment"}
        customerValidation={false}
        requiredPhone={false}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
        payments={payment}
      />
      id = name;
    } else if (name === TabNames.ACH) {
      children = <BankPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerDisabled={false}
        submit={addBankMethod}
        preFillCustomer={subscription && subscription.customer}
        headerText={"Pay With Bank Transfer"}
        buttonText={manualInvoiceDetail ? "Pay" : "Save Payment"}
        iavUrl={`${BASE_URLS.SUBSCRIPTION_LINK}/${id}`}
        customerValidation={true}
        requiredPhone={false}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
      />
      id = name;
    } else if (name === TabNames.UPI) {
      children = <UpiPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={addUPIMethod}
        preFillCustomer={subscription && subscription.currency && subscription.currency.countryAlpha2}
        headerText={"Pay With UPI"}
        buttonText={manualInvoiceDetail ? "Pay" : "Save Payment"}
        customerValidation={true}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
        acquirer={subscription?.acquirer}
      />
      id = name;
    } else if (name === TabNames.GOOGLE_PAY_US) {
      children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={onGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={payment?.account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
            />
          ) : (
            <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={payment}
              chargeByGooglePay={onGooglePay}
              gpaySecretValues={gpaySecretValues}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
            />
          )
        }
      </>
      id = name;
    } else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children, id });
    return panel;
  }, []) : [
    {
      children: <CardPayment
        errorMsg={errorMessage}
        errorHeader={"Error occurred while processing the payment method."}
        customerReadOnly={true}
        submit={onSubmit}
        preFillCustomer={subscription && subscription.customer}
        headerText={"ADD CARD"}
        buttonText={manualInvoiceDetail ? "Pay" : "Save Payment"}
        customerValidation={false}
        requiredPhone={false}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        alpha2={subscription && subscription.currency && subscription.currency.countryAlpha2}
        payments={payment}
      />,
      id : 'CARD'
    }
  ];

  const tabPanelsApple =
      {
    children: <>
      {
        payPalClientAuth ? (
          <ApplePayButton
            recaptchaToken={paypalApplePayRecaptcha}
            amount={payment && payment.amount}
            chargeByApple={onApplePay}
            payment={payment}
            accountGid={payment?.account?.gid}
            successCallback={null}
            failCallback={null}
          />
        ) : (
          <>
            {
              applePayment && isApplePay ?
                <Apple
                  amount={payment && payment.amount}
                  chargeByApple={onApplePay}
                  payment={payment}
                  subscriptionData={subscription}
                  link={link}
                />
                : null
            }
          </>
        )
      }
    </>,
        id: applePayment && isApplePay ? 'APPLE_PAY_US' : null
      }
  ;

  tabPanels.push(tabPanelsApple);

  if (account?.country?.alpha2 === 'US') {
    tabPanels.push({
      children: <SavedPaymentMethods
                  buttonText={manualInvoiceDetail ? "Pay" : "Save Payment"}
                  submit={chargeBySavedPaymentMethods}
                  supportedPaymentTypes={uniquePaymentTypes}
                  accountSupportedPaymentTypes={payment?.account?.supportedPaymentTypes}
                />,
      id: 'SAVED_PAYMENT_METHODS'
    });
  }

  return (
    <BaseSplitPage
    errorHeader={null}
    errorMsg={errorMessage}
    left={
      <>
        <FlexContainer
          flexDirection="column"
          position="relative"
          display="block"
          height="100%"
        >
          <div>
            <LeftBackButtonText
              onClick={() => { props.history.push(`/subscription2-link/${id}`); }}
            >
              Back
            </LeftBackButtonText>
            <H1Text>ADD PAYMENT METHOD</H1Text>
            <div hidden={!(subscription && subscription.description)}>
              <H2Text>Payment For</H2Text>
              <DescriptionText>
                {subscription && subscription.description}
              </DescriptionText>
            </div>
            <div hidden={!(subscription && subscription.planAmount)}>
              <H2Text>
                Amount Payable
              </H2Text>
              <DescriptionText>
                {subscription ? `${currencyFormatter(AmountDivideByHundred(subscription.total), subscription.currency && subscription.currency.name)}` : null}
              </DescriptionText>
            </div>
            <Text
              hidden={!(subscription && (subscription.totalSuccessfulPayments === 0) && (subscription.upfrontAmount !== 0))}
              fontSize="12px"
              marginBottom="20px"
              color="#6b6c6f"
              lineHeight="21px"
            >
              A one-time upfront charge of&nbsp;<span style={{ fontWeight: "600", color: "black" }}>
                {subscription && currencyFormatter(AmountDivideByHundred(subscription.upfrontAmount), subscription.currency && subscription.currency.name)}
              </span>&nbsp;will be added to the first payment.
            </Text>
            <div hidden={!(subscription && subscription.nextPaymentDate)}>
              <H2Text>
                NEXT PAYMENT DUE ON
              </H2Text>
              <DescriptionText>
                {subscription && subscription.nextPaymentDate && getformatteddate(subscription.nextPaymentDate, account && account.timezone)}
              </DescriptionText>
            </div>
          </div>
          <div style={{ position: "sticky", top: "85%" }}>
            <Support email={account && account.support && account.support.email}
              whiteLabel={account && account.whiteLabel}
              phone={account && account.support && account.support.phone} />
          </div>
        </FlexContainer>
      </>
    } right={
      <>
        <Header
          subscription={subscription}
          timeZone={account && account.timezone}
          cancelUrlLink={null}
        />
        {account?.country?.alpha2 === 'US' ? (
          <PaymentExpandableRowsV2
            paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
            tabs={uniquePaymentTypes}
            tabPanels={tabPanels}
            defaultSelectedTab={paymentSelected ? parseInt(paymentSelected) : 0}
            upiDown={upiDownTime}
            applePayment={applePayment}
            isApplePay={isApplePay}
            supportedPaymentTypes={payment?.account?.supportedPaymentTypes}
            account={account}
          /> ) : (
          <PaymentExpandableRows
            paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
            tabs={uniquePaymentTypes}
            tabPanels={tabPanels}
            defaultSelectedTab={paymentSelected ? parseInt(paymentSelected) : 0}
            upiDown={upiDownTime}
            applePayment={applePayment}
            isApplePay={isApplePay}
          />
          )}
        <SmallScreenFooter phone={account && account.support && account.support.phone}
          whiteLabel={account && account.whiteLabel}
          email={account && account.support && account.support.email} children={""} />
        <RecaptchaModal
          visible={recaptchaModalVisible}
          onVerified={onGlobalCaptchaVerified}
        />
        <TransactionModal
          header={"We are verifying your payment method"}
          body={transactionModalBodyText}
          isOpen={isTransactionModalOpen} />
        <SuccessModal isOpen={isTransactionSuccessModalOpen} manualPlaidPayment={manualPlaidPayment} />
        <Spinner isOpen={isShowSpinner} />
      </>
    } />
  )
};

export default AddPaymentMethodV2
